import React from "react";
import Header from "./components/Header";
import Professionals from "./components/Professionals";
import PracticeAreas from "./components/PracticeAreas";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AboutStudio from "./components/AboutStudio";
import "./index.css";

function App() {
  return (
    <div className="bg-background text-gray-900 scroll-smooth">
      <Header />
      <main>
        <AboutStudio />
        <PracticeAreas />
        <Professionals />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
